module.exports = __webpack_public_path__ + "static/media/2021_2A3A0986.76f82eab.jpg";